export default "__VITE_ASSET__CgyEHyfO__"